// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--bg-tertiary);
  overflow: hidden;
  position: relative;
}

/* Background aesthetic element */
.app::before {
  content: '';
  position: absolute;
  top: -10%;
  right: -10%;
  width: 40%;
  height: 40%;
  background: radial-gradient(circle, rgba(153, 27, 27, 0.15) 0%, transparent 70%);
  filter: blur(60px);
  z-index: 0;
  pointer-events: none;
}

.app-container {
  flex: 1;
  display: flex;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.app-sidebar-drawer {
  display: flex;
  height: 100%;
  flex-shrink: 0;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: var(--bg-primary);
  position: relative;
  overflow: hidden;
  min-width: 0;
}

/* Seamless separator */
.main-content::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 1px;
  background: linear-gradient(to bottom, transparent, var(--glass-border), transparent);
}

.app-loading {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-primary);
}

.mobile-sidebar-backdrop {
  display: none;
}

.mobile-members-backdrop {
  display: none;
}

.members-drawer-container {
  display: flex;
  height: 100%;
  flex-shrink: 0;
}

/* Mobile & Small Screen Responsive Styles */
@media (max-width: 768px) {
  .app-container {
    width: 100vw;
    height: 100%;
    position: relative;
    overflow: hidden;
  }

  .app-sidebar-drawer {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    transform: translateX(-100%);
    transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: 6px 0 28px rgba(0, 0, 0, 0.7);
  }

  .app-sidebar-drawer.mobile-open {
    transform: translateX(0);
  }

  .mobile-sidebar-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(4px);
    z-index: 999;
    animation: mobileFadeIn 0.2s ease-out;
  }

  .main-content {
    width: 100vw;
    min-width: 100vw;
    flex: 1;
  }

  .members-drawer-container {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 1000;
    box-shadow: -6px 0 28px rgba(0, 0, 0, 0.7);
    animation: mobileSlideInRight 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  }

  .mobile-members-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.65);
    backdrop-filter: blur(3px);
    z-index: 999;
    animation: mobileFadeIn 0.2s ease-out;
  }
}

@keyframes mobileFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes mobileSlideInRight {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,gFAAgF;EAChF,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,qFAAqF;AACvF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,aAAa;IACb,4BAA4B;IAC5B,yDAAyD;IACzD,yCAAyC;EAC3C;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,0BAA0B;IAC1B,YAAY;IACZ,qCAAqC;EACvC;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,OAAO;EACT;;EAEA;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,QAAQ;IACR,aAAa;IACb,0CAA0C;IAC1C,iEAAiE;EACnE;;EAEA;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,0BAA0B;IAC1B,YAAY;IACZ,qCAAqC;EACvC;AACF;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,wBAAwB,EAAE;AACjC","sourcesContent":[".app {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--bg-tertiary);\n  overflow: hidden;\n  position: relative;\n}\n\n/* Background aesthetic element */\n.app::before {\n  content: '';\n  position: absolute;\n  top: -10%;\n  right: -10%;\n  width: 40%;\n  height: 40%;\n  background: radial-gradient(circle, rgba(153, 27, 27, 0.15) 0%, transparent 70%);\n  filter: blur(60px);\n  z-index: 0;\n  pointer-events: none;\n}\n\n.app-container {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n}\n\n.app-sidebar-drawer {\n  display: flex;\n  height: 100%;\n  flex-shrink: 0;\n}\n\n.main-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--bg-primary);\n  position: relative;\n  overflow: hidden;\n  min-width: 0;\n}\n\n/* Seamless separator */\n.main-content::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: linear-gradient(to bottom, transparent, var(--glass-border), transparent);\n}\n\n.app-loading {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--bg-primary);\n}\n\n.mobile-sidebar-backdrop {\n  display: none;\n}\n\n.mobile-members-backdrop {\n  display: none;\n}\n\n.members-drawer-container {\n  display: flex;\n  height: 100%;\n  flex-shrink: 0;\n}\n\n/* Mobile & Small Screen Responsive Styles */\n@media (max-width: 768px) {\n  .app-container {\n    width: 100vw;\n    height: 100%;\n    position: relative;\n    overflow: hidden;\n  }\n\n  .app-sidebar-drawer {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1000;\n    transform: translateX(-100%);\n    transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n    box-shadow: 6px 0 28px rgba(0, 0, 0, 0.7);\n  }\n\n  .app-sidebar-drawer.mobile-open {\n    transform: translateX(0);\n  }\n\n  .mobile-sidebar-backdrop {\n    display: block;\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.75);\n    backdrop-filter: blur(4px);\n    z-index: 999;\n    animation: mobileFadeIn 0.2s ease-out;\n  }\n\n  .main-content {\n    width: 100vw;\n    min-width: 100vw;\n    flex: 1;\n  }\n\n  .members-drawer-container {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    z-index: 1000;\n    box-shadow: -6px 0 28px rgba(0, 0, 0, 0.7);\n    animation: mobileSlideInRight 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n  }\n\n  .mobile-members-backdrop {\n    display: block;\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.65);\n    backdrop-filter: blur(3px);\n    z-index: 999;\n    animation: mobileFadeIn 0.2s ease-out;\n  }\n}\n\n@keyframes mobileFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes mobileSlideInRight {\n  from { transform: translateX(100%); }\n  to { transform: translateX(0); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
